import React from "react";

import svg from "../../assets/images/icons/no_data.svg";

export const NoDataIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "No Data"}
    />
);
